import Form from 'app/components/Form';

import {
  accountTypeOptions,
  momentOrderOptions,
  createOption
} from 'app/utils/options';

import {
  STANDARD_ACCOUNT_TYPE
} from 'app/utils/Constants';

const AccountForm = props => {
  const {
    account,
    onClose,
    onSubmit,
    action,
    lastUpdate
  } = props;

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  // if feature flags not included in the account type are enabled,
  // or if the account type is set to -1 (or not found),
  // then set the account type to "custom" and add it to the list
  let accountTypeOptions2 = [].concat(accountTypeOptions);
  let accountTypeValue = account?.accountType;
  if (account) {
    let accountType = accountTypeOptions.find(opt => opt.value === account.accountType);
    let isCustom = !accountType;
    if (!isCustom && accountType.value !== STANDARD_ACCOUNT_TYPE) {
      for (let flag in account.feature_flags) {
        if (!accountType.meta.featureFlags.find(f => f === f)) {
          isCustom = true;
          break;
        }
      }
    }
    if (isCustom) {
      let featureFlags = Object.keys(account.feature_flags)
        .filter(key => account.feature_flags[key]);

      accountTypeOptions2.unshift(createOption('Custom', -1, {
        helperText: 'Custom feature flags have been toggled. Feature flags: {featureFlags}',
        meta: {
          featureFlags
        }
      }));

      accountTypeValue = -1;
    }
  }

  let fields = [
    { name: 'name', label: 'Account name', type: 'text', value: account?.name, required: true  },
    { name: 'accountType', label: 'Account type', type: 'select', value: accountTypeValue, valueType: 'integer', options: accountTypeOptions2, hideNoneOption: true },
    { name: 'moment_order', label: 'Moment order', type: 'select', value: account?.moment_order, valueType: 'integer', options: momentOrderOptions, helperText: "Order that moments appear for the user", hideNoneOption: true }
  ]

  // the account type options each have a list of feature flags.
  // these flags will be sent to the server and applied to the account
  const formatParams = params => {
    let accountType = accountTypeOptions.find(opt => opt.value === params.accountType);
    let { featureFlags } = accountType?.meta || {};

    return { ...params, feature_flags: featureFlags };
  }

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit,
      formatParams,
      lastUpdate
    }} />
  );
}

export default AccountForm;
